import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [togglingId, setTogglingId] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    } finally {
      setLoading(false);
    }
  };

  const togglePremium = async (user) => {
    setTogglingId(user._id);
    try {
      const response = await api.put(`/admin/users/${user._id}`, {
        is_premium: !user.is_premium,
      });
      const updated = response.data;
      setUsers((prev) => prev.map((u) => (u._id === updated._id ? updated : u)));
      setMessage({ type: 'success', text: `${updated.username} premium status set to ${updated.is_premium ? 'ON' : 'OFF'}.` });
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to update premium status.' });
    } finally {
      setTogglingId(null);
      setTimeout(() => setMessage(null), 3000);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Users</h1>
        <p className="page-subtitle">Manage platform users</p>
      </div>

      {message && (
        <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
          {message.text}
        </div>
      )}

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              <th>Premium</th>
              <th>Points</th>
              <th>Streak</th>
              <th>Progress</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="8" style={{ textAlign: 'center', padding: '40px' }}>
                  No users found
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user._id}>
                  <td>
                    <strong>{user.username}</strong>
                  </td>
                  <td>{user.email}</td>
                  <td>
                    <span className={`badge ${user.role === 'admin' ? 'badge-warning' : 'badge-success'}`}>
                      {user.role}
                    </span>
                  </td>
                  <td>
                    <button
                      onClick={() => togglePremium(user)}
                      disabled={togglingId === user._id}
                      title="Toggle premium"
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: togglingId === user._id ? 'wait' : 'pointer',
                        fontSize: '18px',
                        opacity: togglingId === user._id ? 0.5 : 1,
                      }}
                    >
                      {user.is_premium ? '⭐' : '○'}
                    </button>
                  </td>
                  <td>{user.coin || 0}</td>
                  <td>🔥 {user.current_streak || 0}</td>
                  <td>📚 {user.last_learned_index || 0}</td>
                  <td>{formatDate(user.createdAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Users;

